import type { ButtonHTMLAttributes, Ref } from "react"
import { cn } from "@/lib/utils"

// 44×44 round icon button — codifies the touch-target recipe so it doesn't
// drift across files. WCAG 2.1 AAA SC 2.5.5 / Apple HIG minimum.
//
// Variant styling (background, border, hover) is supplied by the caller via
// className. This component encodes only the size, shape, focus ring,
// disabled treatment, and icon-centering — the design-language constants.
export function IconButton({
  ref,
  className,
  type = "button",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { ref?: Ref<HTMLButtonElement> }) {
  return (
    <button
      ref={ref}
      type={type}
      className={cn(
        "h-11 w-11 flex items-center justify-center rounded-full flex-shrink-0",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        "disabled:opacity-40 disabled:pointer-events-none",
        className,
      )}
      {...props}
    />
  )
}
